/* KLOKI — patička: mobilní akordeon a přepínač země/jazyka.

   FAIL-OPEN: šablona vykreslí sloupce jako <details open> a přepínač jako
   obyčejný formulář. Když tenhle skript nenaběhne, zůstanou všechny odkazy
   vidět (dnešní chování) a přepínač jen nepřepne — nic se neskryje.

   ⚠️ Akordeon je JEN pod 750 px. Nad tím jsou sloupce vždy otevřené a jejich
   <summary> má v CSS pointer-events:none, takže na desktopu nejde zavřít.  */
(function () {
  'use strict';

  var UZKE = '(max-width: 749px)';

  /* ---------- 1) Akordeon ---------- */
  var sloupce = Array.prototype.slice.call(document.querySelectorAll('.klp__col'));

  function srovnejAkordeon(mobil) {
    sloupce.forEach(function (d) {
      if (mobil) {
        /* Zavřené jsou všechny. Naměřeno na 375 px: každý otevřený sloupec
           přidá ~154 px, a že jde o rozbalovací seznamy, poznat je z nadpisu
           se šipkou — patička pod ním pokračuje pásem newsletteru. */
        d.open = false;
      } else {
        d.open = true;
      }
    });
  }

  if (sloupce.length && window.matchMedia) {
    var mq = window.matchMedia(UZKE);
    srovnejAkordeon(mq.matches);
    var naZmenu = function (e) { srovnejAkordeon(e.matches); };
    if (mq.addEventListener) mq.addEventListener('change', naZmenu);
    else if (mq.addListener) mq.addListener(naZmenu);
  }

  /* ---------- 3) Změna země = jazyk té země ----------
     Shopify si při změně země nechává jazyk, pokud ho cílový trh nabízí: Slovák,
     který na kloki.cz zvolí Slovensko, skončil na kloki-shop.sk/cs, tedy česky
     (naměřeno 28. 9. 2026; totéž CZ → HU dává kloki.hu/cs). Kdo je ve výchozím
     jazyce domény (adresa BEZ jazykové předpony), dostane proto výchozí jazyk
     cílové země. Kdo si jazyk vybral sám (/en, /cs …), tomu zůstane — Shopify
     ho zachová, pokud ho cílový trh má, jinak dá výchozí.
     Platí pro patičku i pro mobilní menu (Dawn localization-form), proto jeden
     posluchač na dokumentu v zachytávací fázi: běží dřív než jejich vlastní
     obsluha kliknutí, která formulář odešle přes form.submit().
     Pole se jmenuje language_code (ne locale_code), aby ho nechytil výběr
     vstupu v obsluze patičky ani v localization-form. */
  var JAZYK_ZEME = { CZ: 'cs', SK: 'sk', DE: 'de', FR: 'fr', HU: 'hu' };
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a[data-value]') : null;
      var form = a && a.closest('form');
      if (!form || !form.querySelector('input[name="country_code"]')) return;
      if (/^\/(cs|sk|de|fr|en|hu)(\/|$)/i.test(location.pathname)) return;
      var jazyk = JAZYK_ZEME[a.getAttribute('data-value')];
      if (!jazyk) return;
      var pole = form.querySelector('input[name="language_code"]');
      if (!pole) {
        pole = document.createElement('input');
        pole.type = 'hidden';
        pole.name = 'language_code';
        form.appendChild(pole);
      }
      pole.value = jazyk;
    } catch (err) { /* fail-open: Shopify rozhodne o jazyce samo */ }
  }, true);

  /* ---------- 2) Přepínač země a jazyka ---------- */
  document.querySelectorAll('.klp-loc-form').forEach(function (form) {
    var disc = form.querySelector('.klp__disc');
    if (!disc) return;

    form.querySelectorAll('.klp__disc-list a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var hodnota = a.getAttribute('data-value');
        if (!hodnota) return;
        var pole = form.querySelector('input[name="country_code"], input[name="locale_code"]');
        if (!pole) return;
        pole.value = hodnota;
        form.submit();
      });
    });

    /* Zavřít, když se klikne mimo nebo stiskne Esc. */
    document.addEventListener('click', function (e) {
      if (disc.open && !disc.contains(e.target)) disc.open = false;
    });

    disc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && disc.open) {
        disc.open = false;
        var s = disc.querySelector('summary');
        if (s) s.focus();
      }
    });
  });
})();
